'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO_LIGHT, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIColorSwatch from 'UIComponents/color/UIColorSwatch';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { CalloutTypes } from '../../constants/callout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.callout.types.${suffix}`;
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "CalloutTypeList__StyledUIFlex",
  componentId: "ef8uuh-0"
})(["cursor:pointer;line-height:1;&:hover,&:active{background-color:", ";}"], CALYPSO_LIGHT);
const propTypes = {
  calloutType: PropTypes.oneOf(Object.keys(CalloutTypes)),
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
function CalloutTypeList(props) {
  const {
    calloutType,
    buttonClassName,
    onClick
  } = props;
  return /*#__PURE__*/_jsx(UIList, {
    children: Object.keys(CalloutTypes).map(type => {
      const {
        accentColor
      } = CalloutTypes[type];
      const isSelected = calloutType === type;
      const handleClick = () => {
        if (!isSelected) {
          onClick(type);
        }
      };
      return /*#__PURE__*/_jsxs(StyledUIFlex, {
        className: buttonClassName,
        align: "center",
        onClick: handleClick,
        onMouseDown: evt => evt.preventDefault(),
        children: [/*#__PURE__*/_jsx(UIColorSwatch, {
          color: accentColor,
          iconColor: OLAF,
          size: 10,
          selected: isSelected
        }), /*#__PURE__*/_jsx("span", {
          className: "m-left-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(type)
          })
        })]
      }, type);
    })
  });
}
CalloutTypeList.propTypes = propTypes;
CalloutTypeList.displayName = 'CalloutTypeList';
export default CalloutTypeList;